import { useFetchUserSettings } from "@sushicorp/services";
import { usePutUserSettings } from "@sushicorp/services";
import React, { useState, useEffect } from "react";

import Styles from "./ProfileNotifications.styles";
import { ProfileNotificationsProps as Props } from "./ProfileNotifications.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import Redirect from "components/global/Redirect/Redirect";
import Switch from "components/global/Switch/Switch";
import NotificationList from "components/profileNotifications/NotificationList/NotificationList";
import CONSTANTS from "config/constants";
import useAuth from "contexts/auth/auth.context.hooks";
import useI18n from "hooks/useI18n";

const { FEATURE_FLAGS } = CONSTANTS;
const { WITH_BOTTOM_SEARCH, WITH_BOTTOM_RESPONSIVE_BUTTONS } = FEATURE_FLAGS;

const ProfileNotifications: React.FC<Props> = props => {
  const [errorMessage, setError] = useState("");
  const auth = useAuth();
  const t = useI18n();
  const { isAnonymous, uid } = auth;
  const { data: userSettings, isLoading, error } = useFetchUserSettings(auth);
  const { mutate: updateUserSettings, isLoading: isLoadingMutation } =
    usePutUserSettings(auth);
  const { settings } = userSettings ?? {};
  const { emailNotifications } = settings ?? {};

  const switchHandler = (value: boolean) => {
    if (!uid) return;
    setError("");

    updateUserSettings(
      {
        uid,
        settings: {
          emailNotifications: value,
          pushNotifications: false
        }
      },
      {
        onError: error => setError(error.message)
      }
    );
  };

  useEffect(() => {
    if (!error) return;
    setError(`${error}`);
  }, [error]);

  if (isAnonymous) {
    return <Redirect pathname="/signin" redirect="/profile/notifications" />;
  }

  return (
    <Styles
      className="ProfileNotifications"
      withBottomSearch={WITH_BOTTOM_SEARCH}
      withBottomResponsiveButtons={WITH_BOTTOM_RESPONSIVE_BUTTONS}
    >
      <header className="ProfileNotifications__header">
        <Navbar showBrand />
      </header>
      <main className="ProfileNotifications__main">
        <ProfileNavigation className="ProfileNotifications__profile-navigation" />
        <div className="ProfileNotifications__content">
          <GoBack className="ProfileNotifications__go-back" title="Atrás" />
          <div className="ProfileNotifications__container">
            <div className="ProfileNotifications__content__header">
              <h2 className="ProfileNotifications__content__title">
                {t.profile.notifications.title}
              </h2>
              <div className="ProfileNotifications__config">
                <p className="ProfileNotifications__config-name">
                  {t.profile.notifications.receiveNotifications}
                </p>
                <Switch
                  name="profile-notifications-switch"
                  checked={emailNotifications ?? false}
                  onChange={switchHandler}
                  isDisabled={isLoading || isLoadingMutation}
                />
              </div>
              {errorMessage ? (
                <p className="ProfileNotifications__switch-error-message">
                  {errorMessage}
                </p>
              ) : null}
            </div>
            <NotificationList />
          </div>
        </div>
      </main>
      <footer className="ProfileNotifications__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileNotifications.defaultProps = {};

export default ProfileNotifications;
